import _str from "shared/util/_str";

// how close to the bottom of the page to trigger a new pageload
export const INFINISCROLL_BUFFER = 400;

// we can put user infomation in two potential places in the store
export const USER_TYPES = {
	TARGET: "targetUser",
	VIEWER: "viewerUser",
};

// importances range from 1, mandatory, to 5, irrelevant. mandatory or very
// important should trigger the header.
export const IMPORTANT_HEADER_TRIGGER = 2;

export const HIGH_MATCH_TRIGGER = 90;

export const FILTERS = {
	// self
	PUBLIC: 1,
	PRIVATE: 2,
	SKIPPED: 3,
	IMPORTANT: 4,
	EXPLAINED: 8,

	// public
	AGREE: 9,
	DISAGREE: 10,
	FIND_OUT: 11,
};

export const FILTER_TITLES = {
	// self
	[FILTERS.PUBLIC]: _str("Public"),
	[FILTERS.PRIVATE]: _str("Private"),
	[FILTERS.SKIPPED]: _str("Skipped"),
	[FILTERS.IMPORTANT]: _str("Important"),
	[FILTERS.EXPLAINED]: _str("Explained"),

	// public
	[FILTERS.AGREE]: _str("Agree"),
	[FILTERS.DISAGREE]: _str("Disagree"),
	[FILTERS.FIND_OUT]: _str("Find out"),
};

export const FILTER_NAMES = {
	// self
	[FILTERS.PUBLIC]: "public",
	[FILTERS.PRIVATE]: "private",
	[FILTERS.SKIPPED]: "skipped",
	[FILTERS.IMPORTANT]: "important",
	[FILTERS.EXPLAINED]: "explained",

	// public
	[FILTERS.AGREE]: "agree",
	[FILTERS.DISAGREE]: "disagree",
	[FILTERS.FIND_OUT]: "findOut",
};

export const SELFVIEW_SORTS = [
	{ value: 0, name: _str("Answered recently") },
	{ value: 1, name: _str("Answered in ancient times") },
];

export const HEADERBAR_HEIGHT = 66;
export const SIDEBAR_MIN_HEIGHT = 581;

export const MOBILE_ANSWER_PORTAL_ID = "mobile-answer-modal-buttons";

export const ANSWERED_ALL_QUESTIONS_KEY = "answeredAllQuestions";



// WEBPACK FOOTER //
// ./src/apps/profile_questions/util/constants.js